import * as React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import SecurityRoutes from 'security-app/routing/Routes';
import { Button } from 'components/bootstrap';
import { Row } from 'common/components';

const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  padding: 7px;
  background-color: ${({ theme }) => theme.colors.global.background};
  border-radius: 6px;
  width: 200px;
`;

type Props = {
  viewType: string;
  useCoreRoutes?: boolean;
};

function EventProcedureTabs({ viewType, useCoreRoutes = false }: Props) {
  const navigate = useNavigate();

  const procedureRoute = !useCoreRoutes
    ? SecurityRoutes.SECURITY_EVENTS.EVENT_PROCEDURES.list('procedures')
    : SecurityRoutes.CORE_EVENTS.EVENT_PROCEDURES.LIST('procedures');
  const stepRoute = !useCoreRoutes
    ? SecurityRoutes.SECURITY_EVENTS.EVENT_PROCEDURES.list('steps')
    : SecurityRoutes.CORE_EVENTS.EVENT_PROCEDURES.LIST('steps');

  return (
    <TabsContainer>
      <Row $align="center" $gap="sm">
        <Button
          bsStyle={viewType === 'procedures' ? 'primary' : 'default'}
          bsSize="small"
          onClick={() => navigate(procedureRoute)}>
          Event Procedures
        </Button>
        <Button
          bsStyle={viewType === 'steps' ? 'primary' : 'default'}
          bsSize="small"
          onClick={() => navigate(stepRoute)}>
          Steps
        </Button>
      </Row>
    </TabsContainer>
  );
}

export default EventProcedureTabs;
